const admissionSettingsReducer = (state = {}, action: any) => {
  switch (action.type) {
    case 'SET_ADMISSION_SETTINGS':
      return action.payload
    default:
      return state
  }
}

export default admissionSettingsReducer
